<template>
  <div>
    <el-popover
      placement="top-start"
      :title="$t('SeaExport.Details')"
      width="500"
      trigger="hover"
      :content="content"
    >
      <span slot="reference">{{ shortContent }}</span>
    </el-popover>
  </div>
</template>
<script>
export default {
  name: 'CargoGridShowBigContent',
  data() {
    return {
      content: '',
      shortContent: ''
    }
  },
  mounted() {
    this.content = this.params.value
    this.shortContent = this.content && this.content.length > 20 ? this.content.substr(0, 20) + '...' : this.content
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>
